import { useState } from "react";
import { Breadcrumb, Button, Card, Tabs } from "antd";
import { useNavigate } from "react-router";
import OwnAccountList from "../send-money/own-account-list";
import FavouritesList from "./favourites-list";
import InternalPayeeList from "./internal/internal-payee-list";
import DomesticPayeeList from "./other/domestic-payee-list";
import { AiOutlineLeft } from "react-icons/ai";
import InternationalPayeeList from "./international/international-payee-list";
import { ReactComponent as TitleIcon } from "../../assests/images/managebreadben.svg";
import AccountCard from "../../components/account-card";
import { useTranslation } from "react-i18next";
import WalletPayeeList from "./wallet/wallet-payee-list";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";
import FEATURE_CONFIG from "client/feature.config.json";

export default function BeneficiaryManagement() {
  const [activeKey, setActiveKey] = useState("INTERNAL");
  const navigate = useNavigate();
  const [beneficiaryManagement, setBeneficiaryManagement] = useState(false);
  const { t } = useTranslation();
  return (
    <>
      <Breadcrumb separator=">" className="hide-xs">
        {/* <Breadcrumb.Item>
          <span onClick={() => navigate("/dashboard")}>
            <HomeIcon height={14} />
          </span>
        </Breadcrumb.Item> */}
        <Breadcrumb.Item>
          <span onClick={() => navigate("/transfer")}>
            {" "}
            {t("navigation.transfer", {
              defaultValue: "Transfers",
            })}
          </span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span>
            {" "}
            {t("pages.Add_Bene.manage_beneficiaries", {
              defaultValue: "Manage Beneficiaries",
            })}
          </span>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {" "}
              {t("pages.Add_Bene.manage_beneficiaries", {
                defaultValue: "Manage Beneficiaries",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <div className="row d-flex justify-content-between">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 hide-xs">
          <Card className="application-card">
            <AccountCard />
          </Card>
        </div>

        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className="account-tab-card mb-1">
            <Tabs
              defaultActiveKey="INTERNAL"
              type="line"
              onChange={setActiveKey}
              activeKey={activeKey}
            >
              {FEATURE_CONFIG.ADD.INTERNAL_BENE && (
                <Tabs.TabPane
                  tab={t("pages.Add_Bene.internal", {
                    defaultValue: "Internal",
                  })}
                  key="INTERNAL"
                ></Tabs.TabPane>
              )}
              {FEATURE_CONFIG.ADD.DOMESTIC_BENE && (
                <Tabs.TabPane
                  tab={t("pages.Add_Bene.domestic", {
                    defaultValue: "Domestic",
                  })}
                  key="DOMESTIC"
                ></Tabs.TabPane>
              )}
              {FEATURE_CONFIG.ADD.INTERNATIONAL_BENE && (
                <Tabs.TabPane
                  tab={t("pages.Add_Bene.international", {
                    defaultValue: "International",
                  })}
                  key="INTERNATIONAL"
                ></Tabs.TabPane>
              )}
              {/* <Tabs.TabPane
                tab={t("pages.Add_Bene.wallet", {
                  defaultValue: "Wallet",
                })}
                key="WALLET"
              ></Tabs.TabPane> */}
              {/* <Tabs.TabPane tab="Favourites" key="FAV"></Tabs.TabPane>
              <Tabs.TabPane tab="My Accounts" key="MY_ACCOUNTS"></Tabs.TabPane> */}
            </Tabs>
          </Card>
          <Card className="send-money-card">
            <div className="row">
              {activeKey === "INTERNAL" && (
                <InternalPayeeList
                  beneficiaryManagement={beneficiaryManagement}
                />
              )}
              {activeKey === "DOMESTIC" && (
                <DomesticPayeeList
                  beneficiaryManagement={beneficiaryManagement}
                />
              )}
              {activeKey === "INTERNATIONAL" && (
                <InternationalPayeeList
                  beneficiaryManagement={beneficiaryManagement}
                />
              )}
              {activeKey === "WALLET" && (
                <WalletPayeeList
                  beneficiaryManagement={beneficiaryManagement}
                />
              )}
              {activeKey === "FAV" && <FavouritesList />}
              {activeKey === "MY_ACCOUNTS" && <OwnAccountList />}
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
